export default __webpack_public_path__ + "static/media/quality.8eef100a.PNG";